import { render, staticRenderFns } from "./kpi-b.vue?vue&type=template&id=0964ce79&scoped=true"
import script from "./kpi-b.vue?vue&type=script&lang=ts"
export * from "./kpi-b.vue?vue&type=script&lang=ts"
import style0 from "./kpi-b.vue?vue&type=style&index=0&id=0964ce79&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0964ce79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0964ce79')) {
      api.createRecord('0964ce79', component.options)
    } else {
      api.reload('0964ce79', component.options)
    }
    module.hot.accept("./kpi-b.vue?vue&type=template&id=0964ce79&scoped=true", function () {
      api.rerender('0964ce79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/kpi-b.vue"
export default component.exports